// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__UjCuv","savePackageButton":"ClientWallet_savePackageButton__XsfoC"};